<app-page-header (myEvent)="refreshPage()">{{ 'meTap' | translate }}</app-page-header>

<div class="main__wrapper" id="appCapsule">
  <div class="header">

    <!-- Not logged in -->
    <ng-container *ngIf="!isUserLoggedIn; else loggedInBlock">
      <a class="profile__content" (click)="loginAccount()" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <ion-icon name="person-circle-outline" style="font-size: 60px; color: #fff;"></ion-icon>
        <h3>{{ 'click_to_login' | translate }}</h3>
      </a>
    </ng-container>

    <!-- Logged in -->
    <ng-template #loggedInBlock>
      <div class="wallet-account">
        <a [routerLink]="['/profile/profile-detail']">
          <div class="account-bgcolor">
            <ng-container *ngIf="!userProfileModel?.imageUrl; else imageBlock">
              <ion-icon name="person-circle-outline" class="account-login-active py-2"></ion-icon>
            </ng-container>
            <ng-template #imageBlock>
              <div class="image__wrapper">
                <img [src]="userProfileModel.imageUrl">
              </div>
            </ng-template>
            <h4 class="mt-2 account-title-active">
              {{ changeName() }}
              <div>{{ userProfileModel.phone_no }}</div>
            </h4>
          </div>
        </a>

        <!-- Waves -->
        <svg class="waves" xmlns="http://www.w3.org/2000/svg" viewBox="0 24 150 28" preserveAspectRatio="none">
          <defs>
            <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s58 18 88 18 58-18 88-18 58 18 88 18v44h-352z" />
          </defs>
          <g class="parallax">
            <use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7)" />
            <use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
            <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
            <use xlink:href="#gentle-wave" x="48" y="7" fill="#fff" />
          </g>
        </svg>
      </div>
    </ng-template>
  </div>

  <!-- Navigation list -->
  <div *ngIf="!loading">
    <ul class="listview image-listview media flush pt-1">

      <!-- Always visible -->
      <li>
        <app-nav-item (click)="goToResult()" iconUrl="assets/img/result.png">
          {{ 'result' | translate }}
        </app-nav-item>
      </li>

      <!-- Logged in only -->
      <ng-container *ngIf="isUserLoggedIn">
        
        <li>
          <app-nav-item (click)="betHistory()" iconUrl="assets/img/bethistory.png">
            {{ 'betHistory' | translate }}
          </app-nav-item>
        </li>

        <li *ngIf="userAgent?.isAgent && userAgent?.my_Referral_code">
          <app-nav-item (click)="goToMyUsers()" iconUrl="assets/img/agent.png">
            {{ 'my_users' | translate }}
          </app-nav-item>
        </li>

        <li *ngIf="userAgent?.isAgent && userAgent?.my_Referral_code">
          <app-nav-item (click)="goToAgentIncome()" iconUrl="assets/img/agent_income.png">
            {{ 'agent_income' | translate }}
          </app-nav-item>
        </li>

        <li *ngIf="showOldGame">
          <app-nav-item (click)="goToWithdrawGame()" iconUrl="assets/img/game-withdraw.png">
            {{ 'withdraw_old_game' | translate }}
          </app-nav-item>
        </li>

        <li *ngIf="userProfileModel?.isGame_agent">
          <app-nav-item (click)="goToSearchingUsers(userProfileModel?.my_gamereferral_code)" iconUrl="assets/img/gamer.png">
            {{ 'search_user' | translate }}
          </app-nav-item>
        </li>

        <li *ngIf="userProfileModel?.isGame_agent && userProfileModel?.my_gamereferral_code">
          <app-nav-item (click)="goToMyGameUsers(userProfileModel?.my_gamereferral_code)" iconUrl="assets/img/income.png">
            {{ 'my_game_users' | translate }}
          </app-nav-item>
        </li>

        <li *ngIf="userAgent?.isAgent && userAgent?.my_Referral_code">
          <app-nav-item (click)="goToTopup()" iconUrl="assets/img/topup-users.png">
            Topup Users
            <div class="badge" badge>{{ topupCount?.topup }}</div>
          </app-nav-item>
        </li>

        <li *ngIf="userAgent?.isAgent && userAgent?.my_Referral_code">
          <app-nav-item (click)="goToNoTopup()" iconUrl="assets/img/no-topup-users.png">
            No Topup Users
            <div class="badge" badge>{{ topupCount?.notopup }}</div>
          </app-nav-item>
        </li>

        <li>
          <app-nav-item (click)="goByRoute('/level')" iconUrl="assets/img/mylevel.png">
            {{ 'my_level' | translate }}
          </app-nav-item>
        </li>

        <li>
          <app-nav-item (click)="bankAccounts()" iconUrl="assets/img/bankacc.png">
            {{ 'my_bank_accounts' | translate }}
          </app-nav-item>
        </li>

        <li>
          <app-nav-item (click)="goByRoute('/profile/change-password')" iconUrl="assets/img/cpassword.png">
            {{ 'changePwd' | translate }}
          </app-nav-item>
        </li>

        <li>
          <app-nav-item (click)="goByRoute('/profile/invite-code')" iconUrl="assets/img/referralcode.png">
            {{ 'enterRef' | translate }}
            <span *ngIf="userProfileModel.referral_code">{{ userProfileModel.referral_code }}</span>
          </app-nav-item>
        </li>

        <li *ngIf="userAgent?.isAgent && userAgent?.my_Referral_code">
          <app-nav-item iconUrl="assets/img/mycode.png">
            {{ 'myenterRef' | translate }}
            <span>{{ userAgent.my_Referral_code }}</span>
          </app-nav-item>
        </li>

        <li>
          <app-nav-item (click)="goByRoute('/profile/gamereferral-code')" iconUrl="assets/img/referralcode.png">
            {{ 'enterGameRef' | translate }}
            <span *ngIf="userProfileModel.gamereferral_code">{{ userProfileModel.gamereferral_code }}</span>
          </app-nav-item>
        </li>

        <li *ngIf="userProfileModel?.isGame_agent">
          <app-nav-item iconUrl="assets/img/mycode.png">
            {{ 'enterMyGameRef' | translate }}
            <span *ngIf="userProfileModel.my_gamereferral_code">{{ userProfileModel.my_gamereferral_code }}</span>
          </app-nav-item>
        </li>

        <li>
          <app-nav-item (click)="goByRoute('/profile/feedback')" iconUrl="assets/img/feedback.png">
            {{ 'feedback' | translate }}
          </app-nav-item>
        </li>

        <li>
          <app-nav-item iconUrl="assets/img/version.png">
            {{ 'version' | translate }} {{ version }}
          </app-nav-item>
        </li>

        <li *ngIf="deviceId">
          <app-nav-item (click)="goByRoute('/profile/me-page/'+deviceId)" iconUrl="assets/img/version-update.png">
            {{ 'cleanCache' | translate }}
          </app-nav-item>
        </li>

        <li>
          <logout></logout>
        </li>

      </ng-container>
    </ul>
  </div>
</div>

<ngx-spinner name="refreshLoading" bdOpacity="0.9" size="medium" color="#00acc1" type="ball-spin-clockwise" [fullScreen]="true"></ngx-spinner>
<app-navigation-bar></app-navigation-bar>
